import React, { memo } from 'react';
import { Content, Footer } from '../../styles';

const FooterSection = ({ ...parallaxProps }) => (
	<Content className='footer' {...parallaxProps}>
		<Footer>
			&copy; 2020 by Inanis Umbra Development.{' '}
			<a href='https://github.com/inanis-umbra/parallax-portfolio'>Github Repository</a>.
			Made by <a href='https://github.com/inanis-umbra'>Inanis Umbra Development</a>.
		</Footer>
	</Content>
);

export default memo(FooterSection);
